module.exports = __webpack_public_path__ + "assets/96cafdaab704277411c6361f8dbbc4f9.png";